(() => {
    const snazzyStyle = [
        {
            featureType: "administrative.locality",
            elementType: "all",
            stylers: [
                {
                    hue: "#c79c60",
                },
                {
                    saturation: 7,
                },
                {
                    lightness: 19,
                },
                {
                    visibility: "on",
                },
            ],
        },
        {
            featureType: "landscape",
            elementType: "all",
            stylers: [
                {
                    hue: "#ffffff",
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: "simplified",
                },
            ],
        },
        {
            featureType: "poi",
            elementType: "all",
            stylers: [
                {
                    hue: "#ffffff",
                },
                {
                    saturation: -100,
                },
                {
                    lightness: 100,
                },
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    hue: "#c79c60",
                },
                {
                    saturation: -52,
                },
                {
                    lightness: -10,
                },
                {
                    visibility: "simplified",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "labels",
            stylers: [
                {
                    hue: "#c79c60",
                },
                {
                    saturation: -93,
                },
                {
                    lightness: 31,
                },
                {
                    visibility: "on",
                },
            ],
        },
        {
            featureType: "road.arterial",
            elementType: "labels",
            stylers: [
                {
                    hue: "#c79c60",
                },
                {
                    saturation: -93,
                },
                {
                    lightness: -2,
                },
                {
                    visibility: "simplified",
                },
            ],
        },
        {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
                {
                    hue: "#c79c60",
                },
                {
                    saturation: -52,
                },
                {
                    lightness: -10,
                },
                {
                    visibility: "simplified",
                },
            ],
        },
        {
            featureType: "transit",
            elementType: "all",
            stylers: [
                {
                    hue: "#c79c60",
                },
                {
                    saturation: 10,
                },
                {
                    lightness: 69,
                },
                {
                    visibility: "on",
                },
            ],
        },
        {
            featureType: "water",
            elementType: "all",
            stylers: [
                {
                    hue: "#c79c60",
                },
                {
                    saturation: -78,
                },
                {
                    lightness: 67,
                },
                {
                    visibility: "simplified",
                },
            ],
        },
    ];

    const getDealerTypes = (el) => {
        const types = [];
        for (let i = 0; i < el.attributes.length; i++) {
            const attr = el.attributes[i];
            if (attr && attr.name == "data-type" && attr.value) {
                types.push(attr.value);
            }
        }
        return Array.from(new Set(types));
    };

    const getSelectedDepartment = () => {
        const select = document.querySelector("#select-department select");
        const checked = select ? select.value : null;
        return checked ? checked : "all";
    };

    const dealers = document.querySelectorAll("[data-dealer]");

    const applyDealerListFilter = (selectedType) => {
        dealers.forEach((dealer) => {
            const dealerTypes = getDealerTypes(dealer);
            if (selectedType === "all" || dealerTypes.includes(selectedType)) {
                dealer.style.display = "block";
            } else {
                dealer.style.display = "none";
            }
        });

        const visibleCount = Array.from(dealers).filter((dealer) => dealer.style.display !== "none").length;
        const countDisplay = document.getElementById("dealer-count");
        if (countDisplay) countDisplay.textContent = visibleCount;

        const single = document.getElementById("dealer-count-label-single");
        const plural = document.getElementById("dealer-count-label-plural");
        if (single && plural) {
            if (visibleCount === 1) {
                single.classList.add("active");
                plural.classList.remove("active");
            } else {
                single.classList.remove("active");
                plural.classList.add("active");
            }
        }
    };

    let applyMarkerFilter = null;
    let lastSortOrigin = null;

    const departmentWrapper = document.getElementById("select-department");
    if (departmentWrapper) {
        departmentWrapper.addEventListener("selectChange", (event) => {
            const selectedType = event.detail.value;
            applyDealerListFilter(selectedType);
            if (applyMarkerFilter) applyMarkerFilter(selectedType);
            if (lastSortOrigin) sortDealerListByDistance(lastSortOrigin);
        });
    }

    applyDealerListFilter(getSelectedDepartment());

    const dealerList = document.querySelector("[data-dealer-list]");
    if (!dealerList) {
        console.warn("Dealer list element not found. Ensure the element with data-dealer-list exists.");
        return;
    }

    Array.from(dealers).forEach((dealer, index) => {
        dealer.setAttribute("data-original-index", index);
    });

    function toRad(value) {
        return (value * Math.PI) / 180;
    }

    function getDistanceInMeters(lat1, lng1, lat2, lng2) {
        const R = 6371000;
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    function sortDealerListByDistance(origin) {
        if (!dealerList || !origin) return;

        lastSortOrigin = origin;

        const items = Array.from(dealerList.querySelectorAll("[data-dealer]"));
        const visibleItems = items.filter((item) => item.style.display !== "none");
        const hiddenItems = items.filter((item) => item.style.display === "none");

        visibleItems.sort((a, b) => {
            const aLat = parseFloat(a.getAttribute("data-latitude"));
            const aLng = parseFloat(a.getAttribute("data-longitude"));
            const bLat = parseFloat(b.getAttribute("data-latitude"));
            const bLng = parseFloat(b.getAttribute("data-longitude"));

            const aHasCoords = !isNaN(aLat) && !isNaN(aLng);
            const bHasCoords = !isNaN(bLat) && !isNaN(bLng);

            if (!aHasCoords && !bHasCoords) {
                return parseInt(a.getAttribute("data-original-index"), 10) - parseInt(b.getAttribute("data-original-index"), 10);
            }

            if (!aHasCoords) return 1;
            if (!bHasCoords) return -1;

            const distanceA = getDistanceInMeters(origin.lat, origin.lng, aLat, aLng);
            const distanceB = getDistanceInMeters(origin.lat, origin.lng, bLat, bLng);

            if (distanceA === distanceB) {
                return parseInt(a.getAttribute("data-original-index"), 10) - parseInt(b.getAttribute("data-original-index"), 10);
            }

            return distanceA - distanceB;
        });

        visibleItems.forEach((item) => dealerList.appendChild(item));
        hiddenItems.forEach((item) => dealerList.appendChild(item));
    }

    dealerList.addEventListener("click", (event) => {
        const toggler = event.target.closest("[data-expand-toggler]");
        if (!toggler) return;
        const expandable = toggler.closest("[data-expandable]");
        if (!expandable) return;
        expandable.classList.toggle("expanded");
    });

    const mapElement = document.querySelector('[data-vd-component="dealer-locator-map"]');
    if (!mapElement) {
        console.warn("Map element not found. Ensure the element with data-vd-component='dealer-locator-map' exists.");
        return;
    }

    const mapKey = mapElement.getAttribute("data-map-key");
    if (!mapKey) {
        console.warn("Map key not found. Ensure the 'data-map-key' attribute is set on the map element.");
        return;
    }

    const currentLocationButton = document.getElementById("current-location");

    ((g) => {
        let h, a, k;
        const p = "The Google Maps JavaScript API";
        const c = "google";
        const l = "importLibrary";
        const q = "__ib__";
        const m = document;
        let b = window;
        b = b[c] || (b[c] = {});
        const d = b.maps || (b.maps = {});
        const r = new Set();
        const e = new URLSearchParams();
        const u = () =>
            h ||
            (h = new Promise(async (f, n) => {
                await (a = m.createElement("script"));
                e.set("libraries", [...r] + "");
                for (k in g)
                    e.set(
                        k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
                        g[k],
                    );
                e.set("language", document.documentElement.lang);
                e.set("callback", c + ".maps." + q);
                a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
                d[q] = f;
                a.onerror = () => (h = n(Error(p + " could not load.")));
                a.nonce = m.querySelector("script[nonce]")?.nonce || "";
                m.head.append(a);
            }));
        d[l] ? console.warn(p + " only loads once. Ignoring:", g) : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
    })({
        key: mapKey,
        v: "weekly",
        libraries: "places,geometry",
    });

    let map;
    let currentInfoWindow;

    async function initMap() {
        const { Map } = await google.maps.importLibrary("maps");
        const { ControlPosition } = await google.maps.importLibrary("core");
        const { spherical } = await google.maps.importLibrary("geometry");

        const MarkerClusterer = markerClusterer?.MarkerClusterer;
        if (!MarkerClusterer) {
            console.warn("MarkerClusterer could not be loaded. Ensure the markerclusterer script is included.");
            return;
        }

        map = new Map(mapElement, {
            zoom: 0.4,
            center: { lat: 24.25, lng: -28.51 },
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: { position: ControlPosition.BLOCK_START_INLINE_START },
            fullscreenControl: true,
            fullscreenControlOptions: { position: ControlPosition.TOP_RIGHT },
            gestureHandling: "greedy",
            styles: snazzyStyle,
        });

        map.addListener("zoom_changed", () => {
            if (currentInfoWindow) {
                currentInfoWindow.close();
                currentInfoWindow = null;
            }
        });

        const data = Array.from(dealers).map((dealer, index) => ({
            header: dealer.querySelector(".title-address-wrapper"),
            content: dealer.querySelector(".more-info"),
            title: dealer.querySelector(".dealer-title")?.textContent?.trim() || "",
            coordinates: {
                latitude: dealer.getAttribute("data-latitude") || "",
                longitude: dealer.getAttribute("data-longitude") || "",
            },
            types: getDealerTypes(dealer),
            index,
        }));

        const locations = data.filter((item) => item.coordinates.latitude && item.coordinates.longitude);

        const markerIcon = {
            url: "/NetSites.JetourKSA.Theme/Images/map_pin.png",
        };

        const markers = [];
        const markersByOriginalIndex = new globalThis.Map();

        for (let i = 0; i < locations.length; i++) {
            const item = locations[i];
            const position = {
                lat: parseFloat(item.coordinates.latitude),
                lng: parseFloat(item.coordinates.longitude),
            };

            const marker = new google.maps.Marker({
                position,
                icon: markerIcon,
                title: item.title || "Dealer location",
            });

            // Keep marker IDs aligned with list item indices used by data-marker-id in templates.
            marker.id = `marker-${item.index}`;
            marker.originalIndex = item.index;
            marker.itemData = {
                header: item.header || null,
                content: item.content || null,
                position,
                types: item.types || [],
            };

            marker.addListener("click", () => handleMarkerClick(marker));
            markers.push(marker);
            markersByOriginalIndex.set(item.index, marker);
        }

        function handleMarkerClick(marker) {
            map.setZoom(17);
            map.panTo(marker.getPosition());

            if (currentInfoWindow) currentInfoWindow.close();

            const infoWindow = createInfoWindow(marker.itemData);
            infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -10) });
            infoWindow.open({ map, anchor: marker });

            currentInfoWindow = infoWindow;
        }
        function findNearestMarkerWithinRadius(targetLocation, candidateMarkers, radiusMeters = 10000) {
            if (!targetLocation || !candidateMarkers.length) return null;

            let nearestMarker = null;
            let nearestDistance = Infinity;

            candidateMarkers.forEach((marker) => {
                const markerPosition = marker.getPosition();
                if (!markerPosition) return;

                const distance = spherical.computeDistanceBetween(targetLocation, markerPosition);

                if (distance < nearestDistance) {
                    nearestDistance = distance;
                    nearestMarker = marker;
                }
            });

            return nearestDistance <= radiusMeters ? nearestMarker : null;
        }

        const clusterRenderer = {
            render: ({ count, position }) => {
                const size = Math.max(34, Math.min(52, 28 + Math.log2(count + 1) * 2));
                const innerRadius = size / 2;
                const outerRadius = innerRadius + 4;
                const iconSize = outerRadius * 2;
                const center = outerRadius;
                const labelSize = "0.688rem";
                const svg = `
                <svg xmlns="http://www.w3.org/2000/svg" width="${iconSize}" height="${iconSize}" viewBox="0 0 ${iconSize} ${iconSize}">
                    <circle cx="${center}" cy="${center}" r="${outerRadius - 1}" fill="none" stroke="#343d4cc4" stroke-width="2"/>
                    <circle cx="${center}" cy="${center}" r="${innerRadius}" fill="#343d4c"/>
                    <text x="${center}" y="${center}" text-anchor="middle" dominant-baseline="middle" fill="#ffffff" font-size="${labelSize}" line-height="1" font-weight="700" font-family="Arial, sans-serif">${count}</text>
                </svg>`;

                return new google.maps.Marker({
                    position,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    icon: {
                        url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
                        scaledSize: new google.maps.Size(iconSize, iconSize),
                        anchor: new google.maps.Point(center, center),
                    },
                });
            },
        };

        const currentMarkerClusterer = new MarkerClusterer({
            map,
            markers,
            renderer: clusterRenderer,
        });

        const singleMarkerZoom = 14;
        const maxAutoZoom = 14;

        function fitBoundsToMarkers(insertedMarkers) {
            if (!insertedMarkers || insertedMarkers.length === 0) return;

            if (insertedMarkers.length === 1) {
                map.setCenter(insertedMarkers[0].getPosition());
                map.setZoom(singleMarkerZoom);
                return;
            }

            const bounds = new google.maps.LatLngBounds();
            insertedMarkers.forEach((marker) => bounds.extend(marker.getPosition()));
            if (bounds.isEmpty()) return;

            map.fitBounds(bounds);

            google.maps.event.addListenerOnce(map, "idle", () => {
                if (map.getZoom() > maxAutoZoom) map.setZoom(maxAutoZoom);
            });
        }

        applyMarkerFilter = (selectedType) => {
            const visibleMarkers = markers.filter((marker) => {
                const markerTypes = marker.itemData?.types || [];
                return selectedType === "all" || markerTypes.includes(selectedType);
            });

            currentMarkerClusterer.clearMarkers();
            currentMarkerClusterer.addMarkers(visibleMarkers);

            if (currentInfoWindow) {
                currentInfoWindow.close();
                currentInfoWindow = null;
            }

            fitBoundsToMarkers(visibleMarkers);
        };

        applyMarkerFilter(getSelectedDepartment());

        const input = document.getElementById("place-autocomplete");
        if (input && window.google && google?.maps?.places) {
            const autocomplete = new google.maps.places.Autocomplete(input, { types: ["geocode"] });

            autocomplete.addListener("place_changed", function () {
                const place = autocomplete.getPlace();
                if (!place.geometry || !place.geometry.location) return;

                const searchLocation = place.geometry.location;

                sortDealerListByDistance({
                    lat: searchLocation.lat(),
                    lng: searchLocation.lng(),
                });

                const selectedType = getSelectedDepartment();
                const visibleMarkers = markers.filter((marker) => {
                    const markerTypes = marker.itemData?.types || [];
                    return selectedType === "all" || markerTypes.includes(selectedType);
                });

                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);

                    google.maps.event.addListenerOnce(map, "idle", function () {
                        if (map.getZoom() < 11) {
                            map.setZoom(11);
                        }
                    });
                } else {
                    map.setCenter(searchLocation);
                    map.setZoom(11);
                }
            });
        }

        const showOnMapButtons = document.querySelectorAll("[data-show-on-map]");
        showOnMapButtons.forEach((button) => {
            button.addEventListener("click", () => {
                const dealer = button.closest("[data-dealer]");
                const originalIndex = dealer ? parseInt(dealer.getAttribute("data-original-index"), 10) : NaN;

                let marker = Number.isInteger(originalIndex) ? markersByOriginalIndex.get(originalIndex) : null;

                if (!marker) {
                    const markerId = button.getAttribute("data-marker-id");
                    marker = markers.find((m) => m.id === markerId);
                }

                if (marker) {
                    handleMarkerClick(marker);
                    return;
                }

                console.warn("Show on map clicked for dealer without valid coordinates.", button);
            });
        });

        if (currentLocationButton) {
            currentLocationButton.addEventListener("click", () => {
                handleLoading(true);

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            const userLocation = { lat: position.coords.latitude, lng: position.coords.longitude };
                            map.setCenter(userLocation);
                            map.setZoom(14);
                            sortDealerListByDistance(userLocation);
                            handleLoading(false);
                        },
                        (error) => {
                            console.error("Error getting current location:", error);
                            alert("Unable to retrieve your location. Please allow location access and try again.");
                            handleLoading(false);
                        },
                        {
                            enableHighAccuracy: true,
                            maximumAge: 0,
                            timeout: 10000,
                        },
                    );
                } else {
                    alert("Geolocation is not supported by this browser.");
                    handleLoading(false);
                }
            });
        }

        handleLoading(false);

        function handleLoading(isLoading) {
            const mapContainer = document.querySelector(".map-container");
            if (!mapContainer) return;
            if (isLoading) mapContainer.classList.add("loading");
            else mapContainer.classList.remove("loading");
        }

        fitBoundsToMarkers(markers);
    }

    function createInfoWindow(item) {
        const headerHtml = item?.header?.innerHTML || "";
        const contentHtml = item?.content?.innerHTML || "";

        const content = `
      <div class="info-window dealer-summary">
        <div class="header title-address-wrapper">${headerHtml}</div>
        <div class="content more-info">${contentHtml}</div>
      </div>
    `;

        return new google.maps.InfoWindow({ content });
    }

    initMap().catch((error) => {
        console.error("Error initializing map:", error);
    });
})();
